import React from "react";
import { useSelector } from "react-redux";
import ReactTooltip from "react-tooltip";

const RankTable = () => {
  const rankData = useSelector((state) => state.brandLeaderboard.totals?.top_ranking);
  if (!rankData?.length) return null;

  return (
    <div className="rank-lists-wrapper">
      {rankData?.map((elem, idx) => (
        <div key={idx}>
          <h4>{elem.title}</h4>
          <ul className="rank-list">
            {elem.content.map((elem, idx) => (
              <li key={idx}>
                {elem.rank}.{" "}
                <span data-tip={elem.name} data-for={elem.name}>
                  {elem.name}
                </span>
                <ReactTooltip id={elem.name} />
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default RankTable;
